import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminEntityTagsQueryKey } from "../entity.keys";
import { EntityId, EntityType } from "./types";

export const useAdminFetchEntityTagsByEntity = ({
	entityType,
	entityId,
}: {
	entityType: EntityType;
	entityId: EntityId;
}) => {
	const { get } = useRequest();

	const { data, isLoading, error, refetch } = useQuery({
		queryKey: adminEntityTagsQueryKey(entityType, entityId),
		queryFn: async () => {
			const response = await get<Dtos.EntityTag.GetByEntity.Response>(
				`/v2/admin/surety/${entityType}s/${entityId}/tags`,
			);
			return response.sort((a, b) => a.displayName.localeCompare(b.displayName));
		},
	});

	return {
		entityTags: data || [],
		entityTagsLoading: isLoading,
		entityTagsError: error,
		refetchEntityTags: refetch,
	};
};
